import React from "react";

export function Checkbox({ label, checked, onChange, className = "" }) {
  return (
    <label
      className={`flex items-center cursor-pointer space-x-2 px-1 ${className}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="w-5.5 h-5.5 text-xl cursor-pointer rounded-full text-primary-600 bg-gray-100 border-gray-300 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-600 dark:ring-offset-gray-800 focus-visible:ring-2 focus:ring-primary-500 focus:dark:ring-offset-gray-800 dark:bg-gray-600 dark:border-gray-500"
      />
      <span className="text-xs font-light leading-tight text-gray-700 dark:text-gray-200">
        {label}
      </span>
    </label>
  );
}
